var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.activeUserId
    ? _c(_setup.UserAvatar, {
        staticClass: "user-tracking-avatar",
        attrs: {
          "user-id": _setup.activeUserId,
          "tooltip-placement": "right",
          "is-small": true,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }